import Image from '../../js/utils/image';

export default (product) => {
  const variant = product.variants[0];
  const tags = product.tags.split(',').map((tag) => tag.trim());

  const getUrl = () => `/products/${product.handle}`;

  const getImages = () => {
    let markup = '';

    if (product.images[0]) {
      markup += Image(product.images[0], 4 / 5);
    }

    if (product.images[1]) {
      markup += Image(product.images[1], 4 / 5);
    }

    return markup;
  };

  const getLabel = () => {
    const labelTag = tags.find((tag) => tag.includes('label_'));
    const labelValue = labelTag?.replace('label_', '') || null;
    const labelValueDowncased = labelValue?.toLowerCase() || null;

    let returnVal = '';

    if (labelValueDowncased === 'bestseller' || labelValueDowncased === 'new') {
      returnVal = window.theme.strings.productItem[labelValueDowncased];
    } else if (labelValue) {
      returnVal = labelValue;
    }

    return returnVal;
  };

  const getTitle = () => {
    let title = '';
    let hasThe = false;

    const splitTitle = product.title.split(' ');

    if (splitTitle[0].toLowerCase() === 'the') {
      hasThe = true;
      title = `<span class="the text-[0.75em] mr-[0.3em]">${splitTitle[0].slice(0, 1).toUpperCase()}${splitTitle[0].slice(1)}</span>`;
    }

    title += `<span class="font-semibold">${hasThe ? splitTitle.slice(1).join(' ') : product.title}</span>`;

    return title;
  };

  const getDetail = () => {
    const detailTag = tags.find((tag) => tag.includes('detail-'));
    const detail = detailTag?.replace('detail-', '') || null;

    return detail ? `<p class="product-item__detail">${detail}</p>` : ''; // eslint-disable-line
  };

  const getCompareAtPrice = () => {
    let markup = '';

    if (parseInt(variant.compare_at_price, 10) > parseInt(variant.price, 10)) {
      markup = `<del>${Shopify.formatMoney(variant.compare_at_price, theme.moneyFormat)}</del>`;
    }

    return markup;
  };

  const getPrice = () => `<span>${Shopify.formatMoney(variant.price, theme.moneyFormat)}</span>`;

  const getFits = () => {
    const fitOptionPosition = product.options.find((option) => option.name.toLowerCase() === 'fit')?.position || null; // eslint-disable-line
    const fits = fitOptionPosition ? [... new Set(product.variants.map((variant) => variant[`option${fitOptionPosition}`]))] : null; // eslint-disable-line

    return fits?.map((fit) => `<li class="product-item__fit-item">${fit}</li>`).join('') || '';
  };

  return window.theme.templates.productItem
    .replaceAll('%url%', getUrl())
    .replaceAll('%productTitle%', product.title)
    .replace('%images%', getImages())
    .replace('%label%', getLabel())
    .replace('%title%', getTitle())
    .replace('%detail%', getDetail())
    .replace('%compareAtPrice%', getCompareAtPrice())
    .replace('%price%', getPrice())
    .replace('%fits%', getFits());
};
